import { Enum } from 'enumify';

export class CheckInOrdenacao extends Enum {}
CheckInOrdenacao.initEnum(['MAIS_RECENTES', 'MAIS_ANTIGOS']);
